import React from 'react';
import { Global, css } from '@emotion/react';
import { CssReset } from './CssReset';
import { PublicoHeadlineFonts } from './PublicoHeadlineFonts';
import { PublicoTextFonts } from './PublicoTextFonts';
import { CarrotTheme } from '../ThemeProvider';
import { createFontFaceObjectCollection } from './util';
import { family } from '../../tokens/font';

const importRemoteCarrotFonts = css`
    @import url('https://cloud.typography.com/6111836/7989992/css/fonts.css');
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans&family=Noto+Sans+Thai+Looped&display=swap');
`;

export default function GlobalStyles(): JSX.Element {
    return (
        <>
            <Global
                styles={(theme: CarrotTheme) => [
                    importRemoteCarrotFonts,
                    ...createFontFaceObjectCollection(PublicoHeadlineFonts(theme)),
                    ...createFontFaceObjectCollection(PublicoTextFonts(theme)),
                    CssReset(theme),
                    {
                        'h1, h2, h3, h4, h5, body': {
                            fontFamily: family.gotham,
                            fontSize: theme.fontSizes.medium,
                        },
                        a: {
                            textDecoration: 'none',
                        },
                        '*': {
                            WebkitBoxSizing: 'border-box',
                            MozBoxSizing: 'border-box',
                            boxSizing: 'border-box',
                        },
                    },
                ]}
            />
        </>
    );
}
